import { useEffect, useState } from 'react';
import ContentLayout from '../../layout/ContentLayout';
import styles from '../../styles/profile.module.scss';
import { Button, Alert } from 'antd';
import DeleteModal from '../../components/modals/DeleteModal';
import { useAuth } from '../../context/useAuth';
import { otherRoles, agentRoles } from '../../router/roles';
import { Link } from 'react-router-dom';
import { deleteUser, fetchUser } from '../../api/user-api';
import Input from '../../components/elements/input/Input';
import { editUserProfile } from '../../api/user-api';
import { toast } from 'react-toastify';
import { fetchAllClinics } from '../../api/medics-api';

const Profile = () => {
  const { user } = useAuth();
  const [clinics, setClinics] = useState([]);
  const [data, setData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    password: '',
    clinicName: '',
  });
  const [dataFormErrors, setDataFormErrors] = useState({
    firstName: false,
    lastName: false,
    email: false,
    phone: '',
    password: false,
    clinicName: '',
  });
  const [error, setError] = useState('');
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [loading, setLoading] = useState(false);

  const toogleShowPassword = () => {
    setPasswordVisible(!passwordVisible);
  };
  const handleClick = () => {};
  const handleOpenModal = () => {
    setIsModalOpen(true);
  };
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleDeleteUserProfile = async () => {
    toast.loading('Brisanje naloga...');
    const { data, success, message } = await deleteUser(user?._id);

    if (success) {
      console.log('test', data);
      toast.dismiss();
      toast.success('Nalog uspešno obrisan.');
      setIsModalOpen(false);
      return;
    }

    console.error(message || 'Error while deleting profile');
  };

  const handleOnChange = (e) => {
    const { name, value } = e.target;

    setData((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  const validateInputs = () => {
    const { firstName, lastName, email, password, clinicName } = data;

    if (user?.role !== 'clinic_owner' && !firstName.trim()) {
      setError('Unesite naziv organizacije.');
      return false;
    }
    if (user?.role !== 'clinic_owner' && !lastName.trim()) {
      setError('Unesite naziv organizacije.');
      return false;
    }
    if (user?.role === 'clinic_owner' && clinicName && !clinicName.trim()) {
      setError('Unesite naziv organizacije.');
      return false;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setError('Unesite validnu adresu e-pošte.');
      return false;
    }
    // password to contain at least one uppercase, one lowercase, one number and one special character
    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!$%_.,#+])[A-Za-z\d!$%_.,#+]{8,}$/;
    if (passwordVisible && !passwordRegex.test(password)) {
      setError(
        'Lozinka mora sadržati najmanje 8 karaktera, uključujući veliko i malo slovo, broj i specijalni karakter (!$%_.,#+).'
      );
      return false;
    }
    setError('');
    return true;
  };

  const handleSubmit = async () => {
    setLoading(true);
    setError(null);

    const isValid = validateInputs();
    if (!isValid) {
      setLoading(false);
      return;
    }
    toast.loading('Ažuriranje podataka...');

    const payloadUser = passwordVisible
      ? {
          firstName: data.firstName,
          lastName: data.lastName,
          email: data.email,
          phone: data.phone,
          newPassword: data.password,
        }
      : {
          firstName: data.firstName,
          lastName: data.lastName,
          email: data.email,
          phone: data.phone,
        };

    const payloadClinic = passwordVisible
      ? {
          clinicName: data?.clinicName,
          email: data?.email,
          phone: data?.phone,
          newPassword: data.password,
        }
      : {
          clinicName: data?.clinicName,
          email: data.email,
          phone: data?.phone,
        };

    const payload = user?.role === 'clinic_owner' ? payloadClinic : payloadUser;

    try {
      const response = await editUserProfile({
        id: user?._id,
        payload,
      });

      if (!response.success) {
        setTimeout(() => {
          setLoading(false);
        }, 1000);
        toast.dismiss();
        toast.error('Došlo je do greške pri ažuriranju podataka.');
        return;
      }
      setTimeout(() => {
        setLoading(false);
      }, 1000);
      toast.dismiss();
      toast.success('Podaci uspešno ažurirani.');
    } catch (error) {
      console.error('Error updating clinic:', error);
      setTimeout(() => {
        setLoading(false);
      }, 1000);
      toast.dismiss();
      toast.error('Došlo je do greške pri ažuriranju podataka.');
    }
  };

  const fetchUserProfile = async () => {
    if (!user?._id) return;

    const { data: fetchedUser, message, error } = await fetchUser(user?._id);
    console.log('fetchedUser', fetchedUser);

    if (error) {
      setError(
        message || 'Došlo je do greške pri učitavanju podataka o korisniku.'
      );
      return;
    }

    setData({
      firstName: fetchedUser?.firstName || '',
      lastName: fetchedUser?.lastName || '',
      email: fetchedUser?.email || '',
      phone: fetchedUser?.phone || '',
      password: '',
    });
  };

  const fetchClinics = async () => {
    try {
      const { data, success, message } = await fetchAllClinics();

      if (!success) {
        console.error(message || 'Error while fetching clinics');
        return;
      }

      console.log('clinics data', data);
      setClinics(data?.clinics || []);
    } catch (error) {
      console.error('Error fetching clinics:', error);
    }
  };
  console.log('clinics', clinics);

  useEffect(() => {
    if (clinics.length > 0) {
      const userClinic = clinics.find((clinic) => clinic.owner === user?._id);
      if (userClinic) {
        setData((prev) => ({
          ...prev,
          clinicName: userClinic?.name || '',
        }));
      }
    }
  }, [clinics]);

  useEffect(() => {
    if (user?.role === 'clinic_owner') {
      fetchClinics();
    }
  }, []);

  useEffect(() => {
    fetchUserProfile();
  }, [user]);
  console.log('user', user);

  return (
    <ContentLayout>
      <div className="edit_medic_wrapper">
        <div className="edit_medic_container">
          <div className="edit_medic_header">
            <Link
              to={`${otherRoles?.includes(user?.role) ? '/clinic-medic' : agentRoles?.includes(user?.role) ? '/agent-home' : '/'}`}
              className="link_btn"
              style={{ marginLeft: 0 }}
            >
              <img alt="back image" src="/assets/icons/chevron.svg" />
              <span>Nazad na početnu</span>
            </Link>
          </div>

          <div className="edit_medic_form_container">
            <div className="edit_medic_form_wrapper">
              <div className="form_header">
                <span className="form_title">Uredi profil</span>
                <Button
                  className={`btn-primary red-button`}
                  // type="primary"
                  onClick={handleOpenModal}
                >
                  <img src="/assets/icons/delete-white.svg" alt="Delete Icon" />
                  <span style={{ marginLeft: '8px' }}>Obriši nalog</span>
                </Button>
              </div>

              <form className="edit_medic_form">
                <div className="grid_row">
                  {user?.role === 'clinic_owner' ? (
                    <div className="cell">
                      <span className="label">Naziv organizacije</span>
                      <Input
                        onChange={(e) => handleOnChange(e)}
                        name="clinicName"
                        id="clinicName"
                        value={data.clinicName}
                        placeholder="Naziv organizacije"
                      />
                    </div>
                  ) : (
                    <>
                      <div className="cell">
                        <span className="label">Ime</span>
                        <Input
                          onChange={(e) => handleOnChange(e)}
                          name="firstName"
                          id="firstName"
                          value={data.firstName}
                          placeholder="Ime"
                        />
                      </div>
                      <div className="cell">
                        <span className="label">Prezime</span>
                        <Input
                          onChange={(e) => handleOnChange(e)}
                          name="lastName"
                          id="lastName"
                          value={data.lastName}
                          placeholder="Prezime"
                        />
                      </div>
                    </>
                  )}
                  <div className="cell">
                    <span className="label">Adresa e-pošte</span>
                    <Input
                      onChange={(e) => handleOnChange(e)}
                      name="email"
                      id="email"
                      value={data.email}
                      placeholder="example@email.com"
                    />
                  </div>
                  <div className="cell">
                    <span className="label">Broj telefona</span>
                    <Input
                        onChange={(e) => handleOnChange(e)}
                        name="phone"
                        id="phone"
                        value={data.phone}
                        placeholder="+381657466322"
                    />
                  </div>
                  <div className="cell">
                    <span className="label">Rola</span>
                    <Input
                      // onChange={(e) => handleOnChange(e)}
                      name="role"
                      id="role"
                      value={user?.role}
                      placeholder="example@email.com"
                      disabled
                      style={{ cursor: 'not-allowed' }}
                    />
                  </div>
                  {user?.role === 'clinic_owner' && (
                    <div className="cell hideonmob"></div>
                  )}
                  <div className="cell">
                    {passwordVisible ? (
                      <>
                        <span className="label">Lozinka</span>

                        <Input
                          onChange={(e) => handleOnChange(e)}
                          name="password"
                          id="password"
                          value={data.password || ''}
                          placeholder="*******"
                          type="password"
                        />
                      </>
                    ) : (
                      <span className="value">*******</span>
                    )}
                  </div>
                  <div className="cell">
                    <div className="reset_password_wrapper">
                      <button
                        type="button"
                        className="link_btn"
                        style={{ marginLeft: 0 }}
                        onClick={toogleShowPassword}
                      >
                        <span>Resetuj lozinku</span>
                      </button>
                    </div>
                  </div>
                </div>

                {error && (
                  <Alert
                    message={error}
                    type="error"
                    showIcon
                    style={{ marginBottom: 16 }}
                  />
                )}

                <div className="row">
                  <div className="submit_wrapper">
                    <Button
                      className="primary_btn"
                      type="button"
                      onClick={() => handleSubmit()}
                      disabled={loading}
                    >
                      <span>
                        {loading ? 'Učitavanje...' : 'Sačuvaj izmene'}
                      </span>
                    </Button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <DeleteModal
          visible={isModalOpen}
          onDelete={handleDeleteUserProfile}
          onCancel={handleCloseModal}
          // loading={loading}
          // done={done}
          title="Da li ste sigurni da želite da obrišete nalog?"
          message="Klikom na dugme “Obriši nalog” će Vaš nalog biti trajno obrisan."
          buttonText="Obriši nalog"
          cancelText="Odustani"
        />
      </div>
    </ContentLayout>
  );
};

export default Profile;
